<script lang="ts">
	import ClipboardIcon from "@lucide/svelte/icons/clipboard";
	import HammerIcon from "@lucide/svelte/icons/hammer";
	import AlertTriangleIcon from "@lucide/svelte/icons/alert-triangle";
	import CalendarClockIcon from "@lucide/svelte/icons/calendar-clock";
	import Section from "#lib/web-ui/primitives/section.svelte";
	import {
		getTemplateContext,
		cloudinaryUrl,
		cloudinarySrcset
	} from "../template-context.svelte";

	const templateContext = getTemplateContext();
</script>

<Section>
	<div class="flex flex-col gap-8 md:flex-row md:gap-12 lg:gap-16">
		<!-- Left image column - aligned with heading -->
		<div class="flex flex-1 items-start">
			<div class="h-full w-full overflow-hidden rounded-lg">
				<img
					src={cloudinaryUrl(templateContext.images.simplify, { width: 768 })}
					srcset={`${cloudinaryUrl(templateContext.images.simplify, { width: 412 })} 412w, ${cloudinaryUrl(templateContext.images.simplify, { width: 640 })} 640w, ${cloudinaryUrl(templateContext.images.simplify, { width: 768 })} 768w`}
					width="640"
					height="427"
					sizes="(max-width: 768px) 100vw, 50vw"
					class="h-full w-full object-cover"
					alt="Simplify every step of the process"
					loading="lazy"
				/>
			</div>
		</div>

		<!-- Right column with heading and content -->
		<div class="flex-1">
			<h2 class="text-primary text-lg font-bold">A Better Way to Sell</h2>
			<p
				class="text-foreground mt-2 text-4xl font-semibold tracking-tight text-pretty sm:text-5xl"
			>
				We Simplify Every Step of the Process
			</p>
			<p class="text-foreground/70 mt-6 text-lg">
				Selling your home fast with {templateContext.siteName} also means avoiding these common
				challenges:
			</p>

			<div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 pt-4 sm:grid-cols-2">
				<div class="space-y-2">
					<div class="flex items-center gap-2">
						<ClipboardIcon class="text-primary size-4" />
						<h3 class="font-medium">Buyer Inspections</h3>
					</div>
					<p class=" text-gray-600">
						Skip bothersome property inspections and scheduling conflicts.
					</p>
				</div>
				<div class="space-y-2">
					<div class="flex items-center gap-2">
						<HammerIcon class="text-primary size-4" />
						<h3 class="font-medium">Costly Repairs</h3>
					</div>
					<p class=" text-gray-600">Sell your home as-is, without hiring contractors.</p>
				</div>
				<div class="space-y-2">
					<div class="flex items-center gap-2">
						<AlertTriangleIcon class="text-primary size-4" />
						<h3 class="font-medium">Unreliable Buyers</h3>
					</div>
					<p class=" text-gray-600">
						Avoid the risk of deals falling through at the last minute.
					</p>
				</div>
				<div class="space-y-2">
					<div class="flex items-center gap-2">
						<CalendarClockIcon class="text-primary size-4" />
						<h3 class="font-medium">Rushed Moving</h3>
					</div>
					<p class=" text-gray-600">
						Move on your timeline, without pressure. We'll handle the rest.
					</p>
				</div>
			</div>
		</div>
	</div>
</Section>
